export default __webpack_public_path__ + "static/media/ynHyK4FNNVN2bf3UmwVPv62r10n2.6fa505d1.jpg";